/**
 * Colour dropdown — thin open/close wrapper around the native swatch fieldset.
 *
 * The trigger displays the currently selected colour and is re-rendered
 * server-side by Liquid on every variant change, so morphdom keeps it in sync
 * automatically. No manual trigger sync needed here.
 *
 * Native radio inputs inside the fieldset are fully tracked by Shopify's
 * variant-picker.js — no changes to that file required.
 */
class ColourDropdown extends HTMLElement {
  #trigger = null;
  #panel = null;
  #outsideClick = (e) => {
    if (!this.contains(e.target)) this.#close();
  };

  connectedCallback() {
    this.#trigger = this.querySelector('.bw-colour-trigger');
    this.#panel = this.querySelector('.bw-colour-panel');
    if (!this.#trigger || !this.#panel) return;

    this.#trigger.addEventListener('click', () => this.#toggle());
    this.#trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.#toggle();
      }
    });

    // Close the panel whenever any radio inside fires a change (colour selected)
    this.addEventListener('change', () => this.#close());

    document.addEventListener('click', this.#outsideClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.#outsideClick);
  }

  #toggle() {
    this.#panel.hidden ? this.#open() : this.#close();
  }

  #open() {
    this.#panel.hidden = false;
    this.#trigger.setAttribute('aria-expanded', 'true');
  }

  #close() {
    this.#panel.hidden = true;
    this.#trigger.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('colour-dropdown')) {
  customElements.define('colour-dropdown', ColourDropdown);
}
